export default __webpack_public_path__ + "static/media/zoneLogo.9a4bd8a2.png";